import {
  DollarOutlined,
  RadarChartOutlined,
  UserOutlined,
} from '@ant-design/icons/lib';
import { MenuEx, MenuItems, MenuPropsEx } from 'common/components/MenuEx';
import { IntlMessage, useFormatMessage } from 'common/hooks/useFormatMessage';
import React, { memo } from 'react';
import {
  BusinessPartnersManagementRoute,
  DevicesManagementRoute,
  AdditionalDevicesManagementRoute,
  DoctorsRoute,
  PatientsRoute,
  UsersRoute,
} from 'routes';

const buildMenuItems: (intlMessage: IntlMessage) => MenuItems = (
  intlMessage
) => [
  {
    key: 'devices',
    icon: <RadarChartOutlined />,
    text: intlMessage({ id: 'devices' }),
    route: DevicesManagementRoute,
  },
  {
    key: 'additional-devices',
    icon: <RadarChartOutlined />,
    text: intlMessage({ id: 'additionalDevices' }),
    route: AdditionalDevicesManagementRoute,
  },
  {
    key: 'businessPartners',
    icon: <DollarOutlined />,
    text: intlMessage({ id: 'businessPartners' }),
    route: BusinessPartnersManagementRoute,
  },
  {
    key: 'users-management',
    icon: <UserOutlined />,
    text: intlMessage({ id: 'users' }),
    children: [
      {
        key: 'users-management/doctors',
        icon: <UserOutlined />,
        text: intlMessage({ id: 'doctors' }),
        route: DoctorsRoute,
      },
      {
        key: 'users-management/users',
        icon: <UserOutlined />,
        text: intlMessage({ id: 'users' }),
        route: UsersRoute,
      },
      {
        key: 'users-management/patients',
        icon: <UserOutlined />,
        text: intlMessage({ id: 'patients' }),
        route: PatientsRoute,
      },
    ],
  },
];

export interface SuperAdminModuleMenuProps
  extends Omit<MenuPropsEx, 'menuItems'> {
  className?: string;
}

export const SuperAdminModuleMenu = memo((props: SuperAdminModuleMenuProps) => {
  const intlMessage = useFormatMessage();

  return (
    <MenuEx
      {...props}
      theme="light"
      mode="inline"
      menuItems={buildMenuItems(intlMessage)}
    />
  );
});
